module.exports = __webpack_public_path__ + "static/media/icon_file_summary.9aeda3ce.svg";